import { axiosInstance } from "../axios";

export const deXuatNhaCungCapApi = {
  create: async (body) => {
    return await axiosInstance.post("/supplier-proposals/forms", body);
  },
  getAll: async (params) => {
    return await axiosInstance.get("/supplier-proposals/forms", { params });
  },
  getById: async (id) => {
    return await axiosInstance.get(`/supplier-proposals/forms/${id}`);
  },
  update: async (id, body) => {
    return await axiosInstance.put(`/supplier-proposals/forms/${id}`, body);
  },
  remove: async (id) => {
    return await axiosInstance.delete(`/supplier-proposals/forms/${id}`);
  },
  addSupplier: async (formId, body) => {
    return await axiosInstance.post(
      `/supplier-proposals/forms/${formId}/proposals`,
      body
    );
  },
  updateSupplier: async (formId, supplierId, body) => {
    return await axiosInstance.put(
      `/supplier-proposals/forms/${formId}/proposals/${supplierId}`,
      body
    );
  },
  getSupplierById: async (formId, supplierId, roleId = "") => {
    return await axiosInstance.get(
      `/supplier-proposals/forms/${formId}/proposals/${supplierId}?role_id=${roleId}`
    );
  },
  deleteSupplier: async (formId, supplierId) => {
    return await axiosInstance.delete(
      `/supplier-proposals/forms/${formId}/proposals/${supplierId}`
    );
  },
  approveSupplier: async (formId, supplierId, body) => {
    return await axiosInstance.put(
      `/supplier-proposals/forms/${formId}/proposals/${supplierId}/approve`,
      body
    );
  },
  getSuppliers: async (formId, supplierId) => {
    return await axiosInstance.get(
      `/supplier-proposals/forms/${formId}/proposals/${supplierId}/approvers`
    );
  },
};
